import type { OnlyFansChatDto } from '@api'

import { DEFAULT_SELECTED_LIST, UNREAD_LIST } from '@/consts/chats.ts'
import type { ChatItem } from '@/modules/chatting/types.ts'

export const prepareChat = (
  chat: OnlyFansChatDto,
  order: number,
): ChatItem => ({
  id: chat.withUser.id,
  lastMessageId: chat.lastMessage?.id,
  receiveDate: Date.now(),
  order,
})

export const matchesConditions = (
  filter: string,
  query: string,
  selectedList: string,
  chat: OnlyFansChatDto,
) => {
  return (
    matchesFilter(filter, chat) &&
    matchesQuery(query, chat) &&
    matchesSelectedList(selectedList, chat)
  )
}

const matchesFilter = (filter: string, chat: OnlyFansChatDto) => {
  if (filter === '') {
    return true
  }

  if (filter === 'priority') {
    return !!chat.lastMessage && !chat.lastMessage.isFromQueue
  }

  if (filter === 'unread') {
    return !!chat.lastMessage && !chat.lastMessage.isReadByCreator
  }

  if (filter === 'unread_tips') {
    return (
      !!chat.lastMessage &&
      !chat.lastMessage.isReadByCreator &&
      chat.lastMessage.isTip
    )
  }

  return false
}

const matchesQuery = (query: string, chat: OnlyFansChatDto) => {
  if (!query || query === '') {
    return true
  }

  return (
    chat.withUser.name.toLowerCase().includes(query.toLowerCase()) ||
    chat.withUser.displayName?.toLowerCase().includes(query.toLowerCase()) ||
    chat.withUser.username?.toLowerCase().includes(query.toLowerCase())
  )
}

const matchesSelectedList = (selectedList: string, chat: OnlyFansChatDto) => {
  return (
    selectedList === DEFAULT_SELECTED_LIST.id ||
    selectedList === UNREAD_LIST.id ||
    !!chat.withUser.listsStates?.find(
      (state) => state.hasUser && state.id === selectedList,
    )
  )
}
